import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import common_de from './locales/de/common.json';
import common_en from './locales/en/common.json';
import pages_de from './locales/de/pages.json';
import pages_en from './locales/en/pages.json';
// Forms imports
import forms_de from './locales/de/forms.json';
import forms_en from './locales/en/forms.json';

// Legal imports  
import legal_de from './locales/de/legal.json';
import legal_en from './locales/en/legal.json';

// Cookies imports
import cookies_de from './locales/de/cookies.json';
import cookies_en from './locales/en/cookies.json';

const resources = {
  de: {
    common: common_de,
    pages: pages_de,
    forms: forms_de,
    legal: legal_de,
    cookies: cookies_de,
  },
  en: {
    common: common_en,
    pages: pages_en,
    forms: forms_en,
    legal: legal_en,
    cookies: cookies_en,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    defaultNS: 'common',
    ns: ['common', 'pages', 'forms', 'legal', 'cookies'],
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
